import { useMemo } from 'react'
import { SelectOption } from '../../../../../../model/selectOption'
import { useProjectPlanSelectData } from './useProjectPlanSelectData'
import { useProjectPrivateContext } from '../../../../../../context/projectContext'
import { resolveSnapshotWbsItemType } from '../../../../lib/snapshotWbsItemType'

type UseProjectPlanSelectOptionsProps = {
  snapshotUuid: string
  selectedUuids: string[]
}

type ProjectPlanSelectOptions = {
  options: SelectOption[]
  parentMap: Record<string, string>
}

export const useProjectPlanSelectOptions = ({
  snapshotUuid,
  selectedUuids,
}: UseProjectPlanSelectOptionsProps): ProjectPlanSelectOptions => {
  const { rows } = useProjectPlanSelectData({ snapshotUuid, selectedUuids })
  const { wbsItemTypes } = useProjectPrivateContext()

  return useMemo(() => {
    const options: SelectOption[] = rows.map(row => ({
      value: row.uuid,
      name: row.displayName,
      iconUrl: resolveSnapshotWbsItemType(row.treeValue, row.type, wbsItemTypes)
        ?.iconUrl,
    }))

    const parentMap: Record<string, string> = {}
    for (const row of rows) {
      const treeValue = row.treeValue
      if (treeValue.length >= 2) {
        parentMap[row.uuid] = treeValue[treeValue.length - 2]
      }
    }

    return { options, parentMap }
  }, [rows, wbsItemTypes])
}
